export default "__VITE_ASSET__Cs20jzEh__"